import { hotCards } from "@/mocks/dashan";

export default function Trending() {
  const big = hotCards[0];
  const rest = hotCards.slice(1);

  return (
    <section id="hot" className="px-4 md:px-6 py-14 md:py-20 bg-background-100/50">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
              <i className="ri-flashlight-line"></i> 今日热瓜
            </span>
            <h3 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              这两天，大家都在围观什么
            </h3>
          </div>
          <span className="hidden sm:inline-flex items-center gap-1.5 text-xs text-foreground-500 bg-background-200/60 px-3 py-1.5 rounded-full">
            <i className="ri-time-line"></i> 每小时更新
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
          {/* 主打卡片 */}
          <a
            href="#opening"
            onClick={(e) => e.preventDefault()}
            className="group relative rounded-3xl overflow-hidden block min-h-[360px] md:min-h-[420px] cursor-pointer"
          >
            <img
              src={big.image}
              alt={big.title}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-transparent"></div>
            <div className="absolute bottom-0 p-6 md:p-8">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs">
                <i className="ri-fire-fill"></i> {big.heat} · {big.category}
              </span>
              <h4 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug max-w-xl">
                {big.title}
              </h4>
              <p className="mt-3 text-background-200/90 text-sm md:text-base leading-relaxed max-w-xl">
                {big.digest}
              </p>
              <p className="mt-4 text-xs text-background-300 inline-flex items-center gap-1.5">
                <i className="ri-eye-line"></i> {big.reads} 次围观 · 点我拆开看
              </p>
            </div>
          </a>

          {/* 侧边卡片列 */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
            {rest.map((c) => (
              <a
                key={c.title}
                href="#case"
                onClick={(e) => e.preventDefault()}
                className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200 flex flex-col cursor-pointer hover:border-primary-300 transition-colors"
              >
                <div className="relative h-40 md:h-44 overflow-hidden">
                  <img
                    src={c.image}
                    alt={c.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs">
                    {c.heat} · {c.category}
                  </span>
                </div>
                <div className="p-4 md:p-5 flex flex-col flex-1">
                  <h4 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug">
                    {c.title}
                  </h4>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3">
                    {c.digest}
                  </p>
                  <p className="mt-3 text-xs text-foreground-500 flex items-center gap-1.5">
                    <i className="ri-eye-line"></i> {c.reads} 次围观
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}